<template>
    <div class="filling-goods-div">
        <div style="padding-top: 5px; font-size: 16px">出库装箱</div>
        <span style="color: red" v-if="hostcs">测试服</span>
        <div style="display: flex; justify-content: space-between; align-items: center;  margin-top: 20px;">
            <van-button type="info" size="small" style="display: flex" :text="ray" @click="holdRay()"></van-button>
            <div>
                <input id="reel-input" class="order-input" @keyup.enter="goGck()" ref="getIDInpot" v-model="reeldata"
                    v-on:blur="hideMessage('reeldata')" readonly autocomplete="off" />
            </div>
        </div>
        <div style="padding:10px 10px; height: 20%;" class="print-only" id="popupPrint">
            <div>
                <div class="list-data">
                    <div class="list-data-div-a">出库单: {{ mxm }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">装箱单: {{ packing_num }}</div>
                </div>
                <!-- <div class="list-data">
                    <div class="list-data-div-a" style="display: flex;">
                        <div style="text-align: left; font-size: 0.48rem; margin-right: 10px;">货位: </div>
                        <input class="list-data-div-a" v-model="goods" disabled>
                    </div>
                </div> -->
                <div class="list-data">
                    <div class="list-data-div-a" style="width:100%">状态: {{ status }}</div>
                </div>
                <div class="list-data">
                    <div class="list-data-div-a">装箱时间: {{ created_at }}</div>
                </div>
            </div>
        </div>
        <div class="filling-goods-bottom" style="display: flex">
            <van-button type="warning" class="bottom-button" @click="go_index()">回首页</van-button>
            <!-- <van-button v-if="AllowPrint" type="info" class="bottom-button" @click="go_picking()">确认装箱</van-button> -->
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations } from "vuex";
import { Dialog } from "vant";
import { Toast } from "vant";
import Barcode from '@/components/Barcode';
import html2canvas from 'html2canvas';
import moment from 'moment';
export default {
    name: "OutPicking", //瑞动专用
    name: "barcode",
    components: {
        Barcode
    },
    data() {
        return {
            hostcs: false,
            more_show: false,
            ray: "扫描中",
            id: "",
            supplier_xh: "",
            count: "",
            count_up: "",
            data: [],
            style: "",
            allcount: 0,
            reeldata: "",
            packing_num: "",
            created_at: "",
            status: "",
            goods: "",
            infoType: "1111",
            gck_number_data: "",
            outNumber: "未出库",
            username: "",
            type: "orderInfo",
            count: "",
            success: false,
            show_print: false,
            AllowPrint: false,
            nowtime: '',
            jieliu: false,
            menfu: '',
            mxm: '',
            cylinder_number: "",
            supplier_name: "",
            JsBarcodeConfigData: {
                text: '', // 条形码必须是字符串类型，否则会出现后面几位为数字的情况。
                lineColor: "#000000", //二维码颜色
                background: "#fff", //二维码背景色
                //width: this.widthStyleObj, 
                bottomtext: '',
            }
        };
    },
    mounted() {
        this.username = JSON.parse(window.localStorage.getItem("userinfo"));
        // if (this.$route.query.id !== undefined) {
        //   this.getIdData(this.$route.query.id);
        // }
        var h = document.documentElement.clientHeight || document.body.clientHeight;
        this.style =
            "text-align: left;width: 100%;height: " + h * 0.66 + "px;overflow:scroll";
        setTimeout(() => {
            // this.countAll();
            if (this.outNumber === "未出库") {
                this.focus();
            }
        }, 500);
        if (window.location.host.indexOf("cspda") !== -1) {
            this.hostcs = true;
        }
    },
    methods: {
        goGck() {
            this.get(this.APIOBJ.outPacking, { out_num: this.reeldata, user_name: this.username }).then(
                (res) => {
                    if (res.data.status == 1) {
                        // 如果是1  就说明成功
                        this.mxm = this.reeldata
                        this.status = res.data.data.status;
                        this.goods = res.data.data.goods;
                        this.created_at = res.data.data.created_at;
                        this.packing_num = res.data.data.packing_num;
                        this.reeldata = '';
                        if (res.data.data.hq == 1) {
                            Dialog.confirm({
                                message: "该订单已经货齐！",
                            })
                                .then(() => {
                                })
                                .catch(() => {
                                    // on cancel
                                });
                        }
                        this.success = true;
                        this.AllowPrint = true;
                    } else if (res.data.status == 0) {
                        Toast(res.data.msg);
                        this.reeldata = '';
                    } else {
                        Toast('失败');
                        this.reeldata = '';
                    }
                }
            );
            this.gck_input();
        },
        go_save() {
            if (this.count_up != "" && this.count_up >= 0) {
                var reduce = this.count - this.count_up;
                //let store=parseFloat(this.count_up);
                this.post(this.APIOBJ.ClothAdjustment, { reel: this.reeldata, comment: this.reelInfo_up, reduce: reduce }).then(
                    (res) => {
                        if (res.data.status == 1) {
                            this.reelInfo = this.reelInfo_up;
                            this.count = this.count_up;
                            Toast('更新保存成功');
                        } else {
                            Toast('更新失败');
                        }
                    }
                )
            }
            else {
                Toast('数量调整不能为空或负!');
            }
        },
        go_picking() {
            // this.get("/IncreaseStore", {
            //   number: this.goods_number,
            //   reel_detail: this.reelInfo,
            //   cylinder_number: this.cylinder_number,
            //   store: this.count,
            //   supplier_name: this.supplier_name,
            //   supplier_xh: this.supplier_xh,
            //   menfu: this.menfu,
            // }).then((res) => {
            //   console.log(res.data);
            //   if (res.data.status == 1) {
            this.nowtime = moment().format('YYYY-MM-DD HH:mm:ss');
            this.JsBarcodeConfigData.text = this.reeldata;
            this.JsBarcodeConfigData.bottomtext = this.reeldata;
            this.show_print = true;
            this.jieliu = false;
            //   } else if (res.data.status == 0) {
            //     this.jieliu = false;
            //     Toast(res.data.msg)
            //   } else {
            //     this.jieliu = false;
            //     Toast("失败");
            //   }
            // })

        },
        dayin() {
            html2canvas(document.querySelector("#popupPrint")).then((canvas) => {
                //document.body.appendChild(canvas);
                var imageBase64 = canvas.toDataURL();// 将imageData作为参数传递给callAndroid()方法
                var imageBase64 = imageBase64.replace(/^data:image\/\w+;base64,/, '');
                this.reelInfo = '';
                this.count = '';
                this.supplier_xh = '';
                this.callAndroid(imageBase64);
            });
        },
        callAndroid(imageBase64) {
            var BASE64_ENCODED_IMAGE_DATA = imageBase64;
            var imageData = BASE64_ENCODED_IMAGE_DATA;
            console.log(imageData);
            this.show_print = false;
            Android.receiveImage(imageData);
            alert("printPreview");
        },
        gck_input() {
            // this.$refs.getGCKInpot.focus();
            // this.$refs.getGCKInpot.setAttribute("readonly", "readonly");
            // setTimeout(() => {
            //   this.$refs.getGCKInpot.removeAttribute("readonly");
            // }, 200);
        },

        hideMessage(title) {
            if (title === "reeldata") {
                if (this.reeldata === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
            if (title === "gck_number_data") {
                if (this.gck_number_data === "") {
                    this.ray = "已暂停，点击我继续扫码";
                }
            }
        },
        holdRay() {
            this.ray = "扫描中";
            if (this.reeldata === "") {
                this.focus();
            } else if (this.gck_number_data === "") {
                this.gck_input();
            }
        },
        focus() {
            this.$refs.getIDInpot.focus();
            this.$refs.getIDInpot.setAttribute("readonly", "readonly");
            setTimeout(() => {
                this.$refs.getIDInpot.removeAttribute("readonly");
            }, 200);
        },
        // gourl(url) {
        //   url = "http://www.lcyjfz.com/home/scan?url=" + url;
        //   window.location.href = url;
        // },
        go_index() {
            Dialog.confirm({
                message: "确定要回首页吗？",
            })
                .then(() => {
                    this.$router.push("/home");
                })
                .catch(() => {
                    // on cancel
                });
        },
        go_scan_url() {
            let url =
                "http://cs.lcyjfz.com/home/scan?id=" + this.$route.query.id || "";
            window.location.href = url;
        },
    },
};
</script>

<style lang="less">
@import "../style/outOrderInfo.less";

.info-data {
    display: flex;
    padding: 0px 10px 10px 10px;
    align-items: center;
    justify-content: center;
}

.bottom-button-x {
    border-radius: 0.5em;
    width: 35%;
}

.list-data {
    display: flex;
    align-items: center;
    margin-top: 10px;
    margin-bottom: 10px;
}

.list-data-div {
    padding-right: 3px;
    text-align: left;
    font-size: 18px;
}

.list-data-div-a {
    text-align: left;
    font-size: 0.48rem;
    width: 50%;
}

.order-input {
    height: 25px;
    width: 3rem;
}
</style>